import LoginPage from "views/Pages/LoginPage.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";
import ForgotPasswordPage from "views/Pages/ForgotPasswordPage.jsx";
import ResetPasswordPage from "views/Pages/ResetPasswordPage.jsx";
import LockScreenPage from "views/Pages/LockScreenPage.jsx";
// @material-ui/icons
import PersonAdd from "@material-ui/icons/PersonAdd";
import Fingerprint from "@material-ui/icons/Fingerprint";
import LockOpen from "@material-ui/icons/LockOpen";
import SecretPage from "../views/Pages/Secret";

const pagesRoutes = [
  {
    path: "/register-page",
    name: "Register Page",
    short: "Register",
    mini: "RP",
    icon: PersonAdd,
    component: RegisterPage
  },
  {
    path: "/forgot-password",
    name: "Register Page",
    short: "Register",
    mini: "RP",
    icon: PersonAdd,
    component: ForgotPasswordPage
  },
  {
    path: "/reset-password",
    name: "Register Page",
    short: "Register",
    mini: "RP",
    icon: PersonAdd,
    component: ResetPasswordPage
  },
  {
    path: "/secret",
    name: "Secret Page",
    short: "Secret",
    mini: "SC",
    icon: PersonAdd,
    component: SecretPage
  },
  {
    path: "/login",
    name: "Login Page",
    short: "Login",
    mini: "LP",
    icon: Fingerprint,
    component: LoginPage
  },
  {
    path: "/confirm-signup",
    name: "Confirmation Page",
    short: "Registration Confirmation",
    mini: "LSP",
    icon: LockOpen,
    component: LockScreenPage
  },
  {
    redirect: true,
    path: "/",
    pathTo: "/login",
    name: "Login Page"
  }
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pages.jsx